import { render, staticRenderFns } from "./Portlet.vue?vue&type=template&id=845809c4"
import script from "./Portlet.vue?vue&type=script&lang=js"
export * from "./Portlet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports